import React, { Dispatch, SetStateAction, useContext, useState } from 'react';
import { ContactInput } from 'sr-types/lib/person/v1/graphql';
import ButtonWithIcon from '../../../common/components/ButtonWithIcon';
import { FormContext } from '../../../common/form/FormContext';
import I18n from '../../../common/i18n/I18n';
import { Icons } from '../../../common/icons/Icons';
import { V } from '../../../common/Layout';
import { usePersonProvider } from '../../PersonContext';
import BusinessContactsEditor from '../editComponents/BusinessContactsEditor';
import QuickAddPersonModal from '../editComponents/QuickAddPersonModal';
import BusinessContactsPreview from './BusinessContactsPreview';

export default function BusinessContacts({
    setIsSaveDisabled,
    directAddContact,
    directDeleteContact
}: {
    setIsSaveDisabled?: Dispatch<SetStateAction<boolean>>;
    directAddContact?: boolean;
    directDeleteContact?: boolean;
}) {
    const { state } = useContext(FormContext);
    const { isBusinessContactEditorOpen, setIsBusinessContactEditorOpen } = usePersonProvider();

    const positionAddButton = state?.businessContacts?.length || isBusinessContactEditorOpen ? 'flex-start' : 'center';

    const [initialState, setInitialState] = useState<ContactInput>(null);
    const [personEditingDetails, setPersonEditingDetails] = useState<ContactInput>(null);
    const [personData, setPersonData] = useState(null);
    const [showPersonEditor, setShowPersonEditor] = useState<boolean>(false);

    const onEditBusinessContact = (contact: ContactInput) => {
        setPersonEditingDetails(contact);
        setIsBusinessContactEditorOpen(true);
        setIsSaveDisabled?.(true);
    };

    const onCloseEditor = () => {
        setIsBusinessContactEditorOpen(false);
        setIsSaveDisabled?.(false);
        setPersonEditingDetails(null);
        setInitialState(null);
    };

    const onAddButtonClicked = () => {
        setIsBusinessContactEditorOpen(true);
        setIsSaveDisabled?.(true);
    };

    return (
        <V fill gap={2} sx={{ justifyContent: positionAddButton, p: 2 }}>
            {isBusinessContactEditorOpen ? (
                <BusinessContactsEditor
                    personEditingDetails={personEditingDetails}
                    onCloseEditor={onCloseEditor}
                    directAddContact={directAddContact}
                    setPersonData={setPersonData}
                    setShowPersonEditor={setShowPersonEditor}
                    initialState={initialState}
                />
            ) : (
                <ButtonWithIcon
                    label={<I18n token="person.business.contact" />}
                    Icon={Icons.AddButton}
                    onClick={onAddButtonClicked}
                    sx={{ alignItems: positionAddButton }}
                />
            )}

            <BusinessContactsPreview onEdit={onEditBusinessContact} directDeleteContact={directDeleteContact} />

            {showPersonEditor && (
                <QuickAddPersonModal
                    personData={personData}
                    setShowPersonEditor={setShowPersonEditor}
                    setInitialState={setInitialState}
                />
            )}
        </V>
    );
}
